module.exports = __webpack_public_path__ + "static/media/background-desapega2-mobile.09e4482a.jpg";